<div *ngIf="organizations && organizations.length > 0">
	<h4>{{ (organizations.length > 1 ? 'fs.res.common.organizations.internal.assignedInternalOrgUnit_plural' : 'fs.res.common.organizations.internal.assignedInternalOrgUnit') | hisUi }}</h4>
	<div>
		<p-table [value]="organizations" [paginator]="false">
			<ng-template pTemplate="header">
				<tr>
					<th>{{ 'fs.res.common.organizations.internal.defaulttext' | hisUi }}</th>
				</tr>
			 </ng-template>
			 <ng-template pTemplate="body" let-orgunit>
				<tr>
					<td>{{orgunit.text}}</td>
				</tr>
			</ng-template>
		</p-table>
	</div>
</div>